import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { handleRequest } from "../../helpers/handleAsync";
import shopService from "../../services/shopService";
import { IShopConfigInfo } from "../../types/shop";
import { setMetaData } from "../../helpers/handleSEO";
import { setShopUsername } from "../../helpers/handleShopContext";
export interface IShopInfo {
    shopInfo: IShopConfigInfo;
    // false cho tới khi biết chắc shop có cần chuyển sang tên miền riêng hay không
    isReady: boolean;
}
const initialState: IShopInfo = {
    isReady: false,
    shopInfo: {
        shop_id: 0,
        shop_name: "",
        shop_phone: "",
        shop_email: "",
        shop_address: "",
        store_title: "",
        store_description: "",
        store_zalo: "",
        store_facebook: "",
        store_whatsapp: "",
        store_logo_url: "",
        shop_checkout_id: 0,
        token: "",
        is_not_found: false
    },
}
const getDataShop = createAsyncThunk(
    'shop/getData',
    async (_, { dispatch }): Promise<boolean> => {
        const [shopConfig, errShopConfig] = await handleRequest(shopService.getShopConfigInfo());
        if (!shopConfig || errShopConfig) {
            // Lỗi API: vẫn phải thoát khỏi màn hình loading, không để spinner quay mãi
            dispatch(setReady(true));
            throw new Error('Error from config shop');
        }
        if (shopConfig.status !== 1 || !!!shopConfig.data) {
            dispatch(setShopInfo({ ...shopConfig?.data, is_not_found: true }));
            dispatch(setReady(true));
            return false;
        }
        setShopUsername(shopConfig.data.username);
        const storeDomain = shopConfig.data.store_domain;
        const isLocal = window.location.hostname === 'localhost';
        if (storeDomain && !isLocal && window.location.hostname !== storeDomain) {
            // Giữ isReady = false để không render giao diện trong lúc trình duyệt chuyển trang
            const { pathname, search, hash } = window.location;
            window.location.replace(`https://${storeDomain}${pathname}${search}${hash}`);
            return false;
        }
        dispatch(setShopInfo({ ...shopConfig?.data, is_not_found: false }));
        dispatch(setReady(true));
        setMetaData({
            title: !!shopConfig?.data.store_title ? shopConfig?.data.store_title : shopConfig?.data.shop_name,
            description: shopConfig?.data.store_description
        })
        return true;
    }
);
export const shopSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setShopInfo(state, action: PayloadAction<IShopConfigInfo>) {
            state.shopInfo = action.payload;
        },
        setReady(state, action: PayloadAction<boolean>) {
            state.isReady = action.payload;
        }
    }
})
export const shopSliceActions = { getDataShop };
export const { setShopInfo, setReady } = shopSlice.actions;
export default shopSlice.reducer;